import { Injectable } from '@angular/core';

import { QueryEntity } from '@datorama/akita';

import { RepliesState } from './replies.state';
import { RepliesStore } from './replies.store';

@Injectable({ providedIn: 'root' })
export class RepliesQuery extends QueryEntity<RepliesState> {
  constructor(protected readonly store: RepliesStore) {
    super(store);
  }
}
